import { BehaviorSubject, Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

export type SparkEvent<T> = {
  event_type: T;
  event_data: any;
}

export abstract class EventService<T> {
  private eventSubject: BehaviorSubject<SparkEvent<T>>;
  private event$: Observable<SparkEvent<T>>;

  constructor(event_type: T, event_data?: any) {
    this.eventSubject = new BehaviorSubject<SparkEvent<T>>({ event_type, event_data });
    this.event$ = this.eventSubject.asObservable();

  }

  fire(event_type: T, event_data?: any) {
    this.eventSubject.next({ event_type, event_data });
  }

  on(event_type: T): Observable<any> {
    return this.event$.pipe(filter(e => e.event_type === event_type), map(e => e.event_data));
  }

  onAny(event_types: T[]): Observable<any> {
    return this.event$.pipe(filter(e => event_types.includes(e.event_type)), map(e => e.event_data));
  }
}